import { defineComponent, useAttrs, computed, createElementBlock, openBlock, normalizeStyle, normalizeClass, unref, renderSlot, createElementVNode, withDirectives, createCommentVNode, toDisplayString, mergeProps, Fragment, renderList, vShow } from "vue";
import { S as SIZES } from "./p-btn.types.js";
import { useInputClasses } from "../useInputClasses.js";
const _hoisted_1 = ["data-has-error"];
const _hoisted_2 = ["value"];
const _hoisted_3 = ["value"];
const nullValue = "___null_value___";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PSelect",
    inheritAttrs: false
  },
  __name: "p-select",
  props: {
    modelValue: {
      type: [String, Number, Boolean, null],
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    errorMsg: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return SIZES.includes(value);
      }
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: [String, Number, Boolean, null],
      default: "value"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const $attrs = useAttrs();
    const { labelClasses, selectClasses, errorMsgClasses } = useInputClasses(props);
    const innerValue = computed({
      get: () => {
        if (props.modelValue === null) {
          return nullValue;
        }
        return props.modelValue;
      },
      set: (v) => emit("update:modelValue", v)
    });
    const attrs = computed(() => {
      const { class: classes, style: style2, ...rest } = $attrs;
      return rest;
    });
    const style = computed(() => $attrs.style);
    const innerOptions = computed(() => {
      return props.items.map((item) => {
        return {
          value: item[props.itemValue] === null ? nullValue : item[props.itemValue],
          text: item[props.itemText]
        };
      });
    });
    const onChange = (e) => {
      const value = e.target.value;
      if (value === nullValue) {
        emit("update:modelValue", null);
        return;
      }
      emit("update:modelValue", ["true", "false"].includes(value) ? value === "true" : value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{ hidden: unref($attrs).hidden }, unref($attrs).class]),
        "data-has-error": !!__props.errorMsg,
        style: normalizeStyle(style.value)
      }, [
        renderSlot(_ctx.$slots, "label", {
          label: __props.label,
          labelClasses: unref(labelClasses)
        }, () => [
          __props.label ? (openBlock(), createElementBlock("label", {
            key: 0,
            class: normalizeClass(unref(labelClasses))
          }, toDisplayString(__props.label), 3)) : createCommentVNode("", true)
        ]),
        createElementVNode("select", mergeProps({ class: unref(selectClasses) }, attrs.value, {
          value: innerValue.value,
          onChange
        }), [
          (openBlock(true), createElementBlock(Fragment, null, renderList(innerOptions.value, (o) => {
            return openBlock(), createElementBlock("option", {
              key: String(o.value),
              value: o.value
            }, toDisplayString(o.text), 9, _hoisted_3);
          }), 128))
        ], 16, _hoisted_2),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(unref(errorMsgClasses))
        }, toDisplayString(__props.errorMsg), 3), [
          [vShow, __props.errorMsg]
        ])
      ], 14, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
